"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMsgDelegate = exports.isMsgSend = void 0;
function isMsgSend(msg) {
    return msg.type === "cosmos-sdk/MsgSend";
}
exports.isMsgSend = isMsgSend;
function isMsgDelegate(msg) {
    return msg.type === "cosmos-sdk/MsgDelegate";
}
exports.isMsgDelegate = isMsgDelegate;
//# sourceMappingURL=msgs.js.map